var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBuilding2 = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "lucide lucide-building2-icon lucide-building-2",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M10 6h4"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M10 10h4"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M10 14h4"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M10 18h4"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBuilding2);
export { ForwardRef as ReactComponent };